module.exports = __webpack_public_path__ + "img/EAST_YEARBOOK-61-min.efc03a24.jpg";